export default "__VITE_ASSET__6E8ISH95__"